import axios from "axios";
import { CSRF_TOKEN } from "@/config";

let csrfToken = CSRF_TOKEN;

export const api = axios.create({
  baseURL: "/api/v1",
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

api.interceptors.request.use((config) => {
  config.headers.set("X-CSRF-Token", csrfToken);
  return config;
});

api.interceptors.response.use((response) => {
  const token = response.headers["x-csrf-token"];
  if (typeof token === "string" && token.length > 0) {
    csrfToken = token;
  }
  return response;
});
